import Styles from '../../../../ArticlesComponents/ArticleWrapper/styles.module.scss';

export default function APITerms() {
  return (
    <>
      <h1>API terms and conditions</h1>
      <p className={Styles['main-subtitle']}>Please read these Terms and Conditions carefully before proceeding to register for our services</p>
      <p>
        These terms of service (together with the documents referred to in it) tell you the terms on which you may order the API information services from Cityfalcon.ai (each,
        {' '}
        <strong>"the site"</strong>
        ).
        <br />
        <br />
        Please read these terms carefully and make sure that you understand them, before ordering any such services from the site.
        <br />
        <br />
        <br />
        Please note that when you register to order services from the site, you will be asked to agree to these terms and these terms
        will form the contract for services created between us for the sale of those services to you (the
        {' '}
        <strong>"Contract for Services”</strong>
        )
        including, where relevant, for free-trials of those services.
        If you do not accept these terms, you will not be able to order any API information services from the site and should refrain
        from attempting to do so.
        <br />
        <br />
        By accessing or using the site or our services, you are confirming your acceptance of these terms and that you agree to be bound
        by them. If you are acting on behalf of a company, you are also confirming that you are authorised to bind the company in this
        way when you are accessing or using the site or our services.
        <br />
        <br />
        You should print a copy of these terms for future reference.
        <br />
        <br />
        We amend these terms from time to time as set out below.  Every time you wish to order services, please check these terms to ensure you understand the terms which will apply at that time.
        <br />
        <br />
        These terms were most recently updated on 26 February 2016.
      </p>
    </>
  );
}
